var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_5977)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4165 19.5832H4.58317C3.66275 19.5832 2.9165 18.8369 2.9165 17.9165V2.08317C2.9165 1.16275 3.66275 0.416504 4.58317 0.416504H12.4886C12.4894 0.416504 12.4907 0.416504 12.4915 0.416504H12.4998C12.6332 0.416504 12.7469 0.483587 12.8232 0.581087L16.9186 4.6765C17.0165 4.75275 17.0832 4.8665 17.0832 4.99984V5.00859C17.0832 5.00942 17.0832 5.00984 17.0832 5.01067V17.9165C17.0832 18.8369 16.3369 19.5832 15.4165 19.5832ZM12.9165 1.82525V4.58317H15.6744L12.9165 1.82525ZM16.2498 5.4165H12.4998C12.2694 5.4165 12.0832 5.22984 12.0832 4.99984V1.24984H4.58317C4.12317 1.24984 3.74984 1.62317 3.74984 2.08317V17.9165C3.74984 18.3765 4.12317 18.7498 4.58317 18.7498H15.4165C15.8765 18.7498 16.2498 18.3765 16.2498 17.9165V5.4165ZM13.7498 16.2498H6.24984C6.01942 16.2498 5.83317 16.0636 5.83317 15.8332C5.83317 15.6032 6.01942 15.4165 6.24984 15.4165H13.7498C13.9803 15.4165 14.1665 15.6032 14.1665 15.8332C14.1665 16.0636 13.9803 16.2498 13.7498 16.2498ZM13.7498 12.9165H6.24984C6.01942 12.9165 5.83317 12.7303 5.83317 12.4998C5.83317 12.2698 6.01942 12.0832 6.24984 12.0832H13.7498C13.9803 12.0832 14.1665 12.2698 14.1665 12.4998C14.1665 12.7303 13.9803 12.9165 13.7498 12.9165ZM13.7498 9.58317H6.24984C6.01942 9.58317 5.83317 9.39692 5.83317 9.1665C5.83317 8.9365 6.01942 8.74984 6.24984 8.74984H13.7498C13.9803 8.74984 14.1665 8.9365 14.1665 9.1665C14.1665 9.39692 13.9803 9.58317 13.7498 9.58317Z",
    fill: "#D4D4D4",
    stroke: "#D4D4D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_5977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCertificate);
export default __webpack_public_path__ + "static/media/manage-certificate.90bbd1d0636adece8a83ad5dff95f60f.svg";
export { ForwardRef as ReactComponent };